import WeatherHealthBadge from "../WeatherHealthBadge";
import {
  resolveAdminFallbackReasonLabel,
  resolveAdminSourceModeLabel,
  resolveFallbackBehaviorCopy,
  resolveSourceLabel,
} from "../../../../../../utils/radarHealthAdminUtils";

function StatusLine({ label, sourceKey, health, status }) {
  const sourceLabel = resolveSourceLabel(sourceKey, health);

  return (
    <div className="weather-radar-fallback__row">
      <span className="weather-radar-fallback__label">{label}</span>
      <span className="weather-radar-fallback__value">{sourceLabel}</span>
      {status ? <WeatherHealthBadge status={status} /> : null}
    </div>
  );
}

const WeatherRadarFallbackPanel = ({ health }) => {
  if (!health) {
    return null;
  }

  const bart = health.sources?.ideamBart;
  const rainViewer = health.sources?.rainViewer;
  const legacyOspa = health.sources?.legacyOspa;

  return (
    <div className="admin-dash__card panel-card weather-radar-fallback">
      <h2 className="admin-section-title">Fallback behavior</h2>

      <p className="weather-radar-fallback__summary" role="status">
        {resolveFallbackBehaviorCopy(health)}
      </p>

      {health.fallbackActive ? (
        <p className="weather-radar-health-notice weather-radar-health-notice--fallback" role="status">
          RainViewer backup is currently rendering because official radar is unavailable.
        </p>
      ) : null}

      <div className="weather-radar-fallback__grid">
        <div className="weather-radar-fallback__row">
          <span className="weather-radar-fallback__label">Source mode</span>
          <span className="weather-radar-fallback__value">
            {resolveAdminSourceModeLabel(health.sourceMode)}
          </span>
        </div>
        <div className="weather-radar-fallback__row">
          <span className="weather-radar-fallback__label">Preferred source</span>
          <span className="weather-radar-fallback__value">
            {resolveSourceLabel(health.preferredSource, health)}
          </span>
        </div>
        <div className="weather-radar-fallback__row">
          <span className="weather-radar-fallback__label">Rendered source</span>
          <span className="weather-radar-fallback__value">
            {resolveSourceLabel(health.renderedSource, health)}
          </span>
        </div>
        <div className="weather-radar-fallback__row">
          <span className="weather-radar-fallback__label">Fallback active</span>
          <span className="weather-radar-fallback__value">{health.fallbackActive ? "Yes" : "No"}</span>
        </div>
        <div className="weather-radar-fallback__row">
          <span className="weather-radar-fallback__label">Fallback reason</span>
          <span className="weather-radar-fallback__value">
            {resolveAdminFallbackReasonLabel(health.fallbackReason)}
          </span>
        </div>
      </div>

      <div className="weather-radar-fallback__sources">
        <StatusLine label="BART status" sourceKey={bart?.source} health={health} status={bart?.status} />
        {health.sources?.siataSantaElena ? (
          <StatusLine
            label="SIATA status"
            sourceKey={health.sources.siataSantaElena.source || health.sources.siataSantaElena.sourceKey}
            health={health}
            status={health.sources.siataSantaElena.status}
          />
        ) : null}
        <StatusLine
          label="RainViewer status"
          sourceKey={rainViewer?.source}
          health={health}
          status={rainViewer?.status}
        />
        {legacyOspa ? (
          <StatusLine
            label="OSPA status"
            sourceKey={legacyOspa.source}
            health={health}
            status={legacyOspa.status}
          />
        ) : null}
      </div>
    </div>
  );
};

export default WeatherRadarFallbackPanel;
